// MWC Watch Detail - Recommendations module
// Loads approved strap recommendations for the current user watch.
// Enriches recommendation handles with Shopify product data via /products/{handle}.js.

(function () {
  window.MWCWatchDetailRecommendations = {
    render: renderRecommendations
  };

  async function renderRecommendations(watch) {
    const constants = window.MWCWatchDetailConstants || {};
    const selectors = constants.selectors || {};
    const routes = constants.routes || {};
    const defaults = constants.defaults || {};

    const block = document.querySelector(
    selectors.recommendations || "[data-mwc-recommendations]"
    );
    if (!block || !watch || !watch.id) return;

    const textEl = block.querySelector(
      selectors.recommendationText || "[data-mwc-recommendation-text]"
    );

    const productsEl = block.querySelector(
      selectors.recommendationProducts || "[data-mwc-recommendation-products]"
    );

    if (!textEl || !productsEl) {
      block.style.display = "none";
      return;
    }

    block.style.display = "none";
    textEl.textContent = "";
    productsEl.innerHTML = "";

    try {
      const data = await MWC.getRecommendations({
        user_watch_id: watch.id,
        shop: defaults.shop || "NL"
      });

      if (!data || !Array.isArray(data.products) || !data.products.length) {
        block.style.display = "none";
        return;
      }

      textEl.textContent =
        data.title ||
        defaults.recommendationFallbackTitle ||
        "Aanbevolen straps voor dit horloge";

      const enrichedProducts = await Promise.all(
        data.products.map(async function (recommendation) {
          try {
            const productUrl = routes.productJson
            ? routes.productJson(recommendation.handle)
            : "/products/" + encodeURIComponent(recommendation.handle) + ".js";

            const product = await fetch(productUrl, {
              credentials: "same-origin"
            }).then(function (res) {
              if (!res.ok) {
                throw new Error("Product not found: " + recommendation.handle);
              }

              return res.json();
            });

            return {
              recommendation: recommendation,
              product: product
            };
          } catch (error) {
            console.error("Failed to load Shopify product", recommendation.handle, error);
            return null;
          }
        })
      );

      const visibleProducts = enrichedProducts.filter(function (item) {
        return item && item.product && item.product.available;
      });

      if (!visibleProducts.length) {
        block.style.display = "none";
        return;
      }

      const carouselId = "mwc-recommendation-carousel-" + String(watch.id).replace(/[^a-zA-Z0-9_-]/g, "");
      const productList = visibleProducts.map(function (item) {
        return renderRecommendationProduct(item, watch);
      }).join("");

      productsEl.innerHTML = `
        <product-list class="mwc-recommendation-carousel floating-controls-container floating-controls-container--inside floating-controls-container--on-hover">
          <scroll-carousel id="${escapeHtml(carouselId)}" group-cells allow-drag class="mwc-recommendation-list product-list product-list--carousel scroll-area bleed md:unbleed">
            ${productList}
          </scroll-carousel>

          ${visibleProducts.length > 1 ? `
            <button is="carousel-prev-button" type="button" class="prev-next-button prev-next-button--prev circle-button hover:animate-icon-inline" aria-controls="${escapeHtml(carouselId)}" disabled>
              <span class="sr-only">Previous recommendation</span>
              ${renderArrowIcon("left")}
            </button>

            <button is="carousel-next-button" type="button" class="prev-next-button prev-next-button--next circle-button hover:animate-icon-inline" aria-controls="${escapeHtml(carouselId)}">
              <span class="sr-only">Next recommendation</span>
              ${renderArrowIcon("right")}
            </button>
          ` : ""}
        </product-list>
      `;

      block.style.display = "";
    } catch (error) {
      console.error("Failed to load recommendations", error);
      block.style.display = "none";
    }
  }

  function normalizeShopifyImageUrl(url) {
    if (!url) return "";

    if (url.indexOf("//") === 0) {
      return "https:" + url;
    }

    return url;
  }

  function formatShopifyPrice(priceInCents) {
    if (priceInCents == null || priceInCents === "") return "";

    const amount = Number(priceInCents) / 100;

    if (Number.isNaN(amount)) return "";

    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR"
    }).format(amount);
  }

  function renderRecommendationProduct(item, watch) {
    const product = item.product;
    const recommendation = item.recommendation;

    const imageUrl = normalizeShopifyImageUrl(
      product.featured_image ||
      (product.images && product.images[0]) ||
      ""
    );

    const watchName = [
      watch.brand,
      watch.model
    ].filter(Boolean).join(" ");

    const displayTitle = watchName
      ? "Strap for " + watchName + " - " + (product.title || recommendation.title || "")
      : (product.title || recommendation.title || "");

    const matchedVariant = findRecommendedVariant(product, recommendation, watch);
    const price = formatShopifyPrice(matchedVariant ? matchedVariant.price : product.price);
    const productUrl = buildRecommendedProductUrl(
      product.url || ("/products/" + product.handle),
      matchedVariant,
      recommendation,
      watch,
      displayTitle
    );

    return `
      <div class="mwc-recommendation-product">
        <a href="${escapeHtml(productUrl)}" class="mwc-recommendation-product__image-link">
          ${imageUrl ? `
            <img
              src="${escapeHtml(imageUrl)}"
              alt="${escapeHtml(product.title || "")}"
              class="mwc-recommendation-product__image"
              loading="lazy"
            >
          ` : `
            <span class="mwc-recommendation-product__image-placeholder"></span>
          `}
        </a>

        <div class="mwc-recommendation-product__info v-stack gap-2">
          <a href="${escapeHtml(productUrl)}" class="mwc-recommendation-product__title">
            ${escapeHtml(displayTitle)}
          </a>

          ${price ? `
            <div class="mwc-recommendation-product__price text-sm">
              ${escapeHtml(price)}
            </div>
          ` : ""}

          ${recommendation.recommendation_text ? `
            <div class="mwc-recommendation-product__reason text-xs text-subdued">
              ${escapeHtml(recommendation.recommendation_text)}
            </div>
          ` : ""}

          <div>
            <a href="${escapeHtml(productUrl)}" class="button button--outline button--sm">
              View strap
            </a>
          </div>
        </div>
      </div>
    `;
  }

  function renderArrowIcon(direction) {
    const transform = direction === "left" ? "rotate(180 8 8)" : "";

    return `
      <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16">
        <path d="M6 3.5L10.5 8L6 12.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" transform="${transform}"></path>
      </svg>
    `;
  }

  function buildRecommendedProductUrl(productUrl, variant, recommendation, watch, displayTitle) {
    var url = productUrl || "";
    var params = [];
    var variantId = variant && normalizeVariantId(variant.id);
    var lugWidth = getRecommendedLugWidth(recommendation, watch);

    if (variantId) {
      params.push("variant=" + encodeURIComponent(variantId));
    }

    if (lugWidth) {
      params.push("mwc_lug_width=" + encodeURIComponent(lugWidth));
    }

    if (displayTitle) {
      params.push("mwc_title=" + encodeURIComponent(displayTitle));
    }

    if (params.length) {
      url += (url.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }

    return url;
  }

  function findRecommendedVariant(product, recommendation, watch) {
    if (!product || !Array.isArray(product.variants)) return null;

    var variantId = normalizeVariantId(recommendation && recommendation.shopify_variant_id);

    if (variantId) {
      var exactVariant = product.variants.find(function (variant) {
        return normalizeVariantId(variant && variant.id) === variantId;
      });

      if (exactVariant) return exactVariant;
    }

    var lugWidth = normalizeLugWidth(getRecommendedLugWidth(recommendation, watch));
    if (!lugWidth) return null;

    return product.variants.find(function (variant) {
      return Array.isArray(variant.options) && variant.options.some(function (option) {
        return normalizeLugWidth(option) === lugWidth;
      });
    }) || null;
  }

  function getRecommendedLugWidth(recommendation, watch) {
    return (
      recommendation &&
      recommendation.attributes &&
      recommendation.attributes.lug_width_mm
    ) || (watch && watch.lug_width) || "";
  }

  function normalizeVariantId(value) {
    if (value == null || value === "") return "";

    var match = String(value).match(/(\d+)$/);
    return match ? match[1] : String(value);
  }

  function normalizeLugWidth(value) {
    if (value == null || value === "") return "";

    var match = String(value).replace(",", ".").match(/\d+(?:\.\d+)?/);
    if (!match) return "";

    return String(Number(match[0]));
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
})();
